export enum SubscriptionEntitlements {
  // Type: Meter
  CreatorSearch = "feature_creator_search",
  ProjectsLimit = "feature_campaigns",
  TasksLimit = "feature_objects",
  MembersLimit = "feature_seats",

  // Type: Bool
  CouponsIntegration = "feature_e_commerce_coupons_integration",
  ContactDataVisibility = "feature_creator_contact_data_visibility",
  WsMessengerExtension = "feature_creator_messenger",
  PublicationSentiments = "feature_sentiments",
  Forms = "feature_forms",
  ClientMode = "feature_client_mode",
  WsXtrmExtension = "feature_influencer_payments",
  DictionaryManager = "feature_flex_fields",
  WhiteLabel = "feature_whitelabel",
  APIAccess = "feature_google_sheets_api",
  HashtagLiveSearch = "feature_hashtag_live_search",
  StorePublishedContentsExtension = "feature_store_published_contents",
  SocialInsights = "feature_social_insights",
}

export interface SubscriptionData {
  customerId: string;
  clientApiKey: string;
  bdWsMemberEmail: string;
  initialWsSubscriptionPlanId?: string | null;
  calendly_invitation_url?: string | null;
  market?: string | null;
  availableMarkets?: string[];
}
